module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iR5Tz"))).then(() => parcelRequire('1iHdE'));